import React from 'react';
import PrimaryButton from '../../../common/buttons';
import { ButtonProps } from './Button';

function UtilityButton(props: ButtonProps) {
  return <PrimaryButton className="utility" {...props} />;
}

export default UtilityButton;
